import { Component, OnInit } from "@angular/core";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { LocationService } from "src/app/services/autopac/location.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NotifierService } from "angular-notifier";
import { getEmptyGuid } from "../../../../services/util.service";

@Component({
  selector: "app-location-master-list",
  templateUrl: "./location-master-list.component.html",
  styleUrls: ["./location-master-list.component.css"],
})
export class LocationMasterListComponent implements OnInit {
  faPlus = faPlus;
  faTrash = faTrash;

  constructor(
    private locationService: LocationService,
    private router: Router,
    private route: ActivatedRoute,
    private notifier: NotifierService,
  ) {}

  tableHeaders = [
    {
      title: "",
      type: "checkbox",
      id: "Checked",
    },
    {
      title: "LOCATION",
      type: "link",
      id: "Location",
    },
    {
      title: "CHEQUE FROM",
      type: "data",
      id: "ChequeFrom",
      classes: "max-w-64",
    },
    {
      title: "CHEQUE TO",
      type: "data",
      id: "ChequeTo",
    },
    {
      title: "CURRENT CHEQUE",
      type: "data",
      id: "CurrentCheque",
    },
    {
      title: "ID",
      type: "hidden",
      id: "Id",
    },
  ];

  tableEntries: any[] = [];

  ngOnInit(): void {
    this.locationService.getAll().subscribe({
      next: (response) => {
        this.tableEntries = response.body.map((entry: any) => ({
          ...entry,
          Checked: false,
        }));
      },
      error: (error) => {
        console.error("Error fetching locations:", error);
      },
    });
  }

  openEntry(value: any): void {
    this.router.navigate(["../location-master", value.Id], {
      relativeTo: this.route,
    });
  }

  addEntry(): void {
    const emptyGuid = getEmptyGuid();
    this.router.navigate(["../location-master", emptyGuid], {
      relativeTo: this.route,
    });
  }

  deleteSelectedEntries(): void {
    const selected = this.tableEntries.filter((x) => x.Checked);

    if (selected.length === 0) {
      this.notifier.notify(
        "error",
        "Please select at least one item to delete",
      );
      return;
    }

    const payloadItems = selected.map(({ Checked, ...rest }) => ({
      __type: "KAPS.Model.Autopac.CrmLocation",
      ...rest,
    }));

    this.locationService.deleteLocations(payloadItems).subscribe({
      next: () => {
        this.notifier.notify(
          "success",
          "Selected items deleted successfully",
        );
        this.tableEntries = this.tableEntries.filter(
          (x) => !x.Checked,
        );
      },
      error: (error) => {
        console.error("Error deleting locations:", error);
        this.notifier.notify(
          "error",
          "Error deleting selected items.",
        );
      },
    });
  }
}
